import styled from 'styled-components';
import { colors, spacing, subtleShadow } from 'ui/theme';

export const NavSliderContent = styled.div`
  overflow: hidden;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const NavSliderHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  padding: ${spacing.base} ${spacing.base} ${spacing.base} ${spacing.plusHalf};
  background: ${colors.backgroundPrimary};
  border-bottom: 1px solid ${colors.borderPrimarySubtle};
  ${subtleShadow}
`;

export const NavSliderCloseBtn = styled.div`
  display: inline-block;
  align-self: self-start;
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  color: ${colors.textPrimary};
`;
